import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomModalComponent {

  private _isOpen = false;

  @Input()
  set isOpen(isOpen: boolean) {
    if (!!isOpen !== this._isOpen) {
      this._isOpen = isOpen;

      if (!isOpen) {
        this.onClose.emit();
      }
    }
  }

  get isOpen(): boolean {
    return this._isOpen;
  }

  @Input() readonly title: string;

  @Output() readonly onClose = new EventEmitter<void>();

}
